import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import CV from './pages/CV';
import Courses from './pages/Courses';
import Projects from './pages/Projects';
import Papers from './pages/Papers';
import Links from './pages/Links';
import Announcements from './pages/Announcements';
import Lab from './pages/Lab';
import Statistics from './pages/Statistics';
import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cv" element={<CV />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/papers" element={<Papers />} />
            <Route path="/links" element={<Links />} />
            <Route path="/announcements" element={<Announcements />} />
            <Route path="/lab" element={<Lab />} />
            <Route path="/statistics" element={<Statistics />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

